import Settings from "./";
export default [
  {
    type: "private",
    path: "/settings",
    component: Settings,
    exact: true,
    private: true
  }
];



// WEBPACK FOOTER //
// ./src/views/settings/_routes.js